import type { ReactNode } from 'react';
import { useState } from 'react';

interface Props {
  children: (props: { isLoading: boolean }) => ReactNode;
}

const TagsProvider = ({ children }: Props) => {
  const [isLoading] = useState(false);

  return children({ isLoading });
};

export default TagsProvider;
